const log = text => process.env.REACT_APP_ENV !== 'PROD' && console.log(text);
const warn = text => process.env.REACT_APP_ENV !== 'PROD' && console.warn(text);
const error = text =>
  process.env.REACT_APP_ENV !== 'PROD' && console.error(text);

export default {
  log,
  warn,
  error,
};



// WEBPACK FOOTER //
// ./src/helper/message.js